module.exports = __webpack_public_path__ + "21ac6ca768048978b8d9d0d6732fabf6.png";